namespace GeniuzPOS.AdvPromo {
    export interface AdvancedPromoReportForm {
        PromoCampaign: Serenity.LookupEditor;
        PmId: Serenity.StringEditor;
        PmExtCode: Serenity.StringEditor;
        PmDesc: Serenity.StringEditor;
        PmGroupId: Serenity.StringEditor;
        PmGroupDesc: Serenity.StringEditor;
        PmType: Serenity.LookupEditor;
        PPtype: Serenity.LookupEditor;
        PmTypeDesc: Serenity.StringEditor;
        StartPromoDate: Serenity.DateEditor;
        EndPromoDate: Serenity.DateEditor;
        PromoTimeFg: Serenity.RadioButtonEditor;
        StartPromoTime: Serenity.StringEditor;
        EndPromoTime: Serenity.StringEditor;
        PromoDayFg: Serenity.RadioButtonEditor;
        PromoDay: Serenity.StringEditor;
        PromoShopFg: Serenity.RadioButtonEditor;
        PromoShop: Serenity.StringEditor;
        PromoCustFg: Serenity.EnumEditor;
        PromoCust: Serenity.StringEditor;
        VenderSharing: Serenity.DecimalEditor;
        PromoStatus: Serenity.RadioButtonEditor;
        ItemList: Adv05ItemDetailsEditor;
        ItemExList: Adv05ItemExDTsEditor;
    }

    export class AdvancedPromoReportForm extends Serenity.PrefixedContext {
        static formKey = 'AdvPromo.AdvancedPromoReport';
        private static init: boolean;

        constructor(prefix: string) {
            super(prefix);

            if (!AdvancedPromoReportForm.init)  {
                AdvancedPromoReportForm.init = true;

                var s = Serenity;
                var w0 = s.LookupEditor;
                var w1 = s.StringEditor;
                var w2 = s.DateEditor;
                var w3 = s.RadioButtonEditor;
                var w4 = s.EnumEditor;
                var w5 = s.DecimalEditor;
                var w6 = Adv05ItemDetailsEditor;
                var w7 = Adv05ItemExDTsEditor;

                Q.initFormType(AdvancedPromoReportForm, [
                    'PromoCampaign', w0,
                    'PmId', w1,
                    'PmExtCode', w1,
                    'PmDesc', w1,
                    'PmGroupId', w1,
                    'PmGroupDesc', w1,
                    'PmType', w0,
                    'PPtype', w0,
                    'PmTypeDesc', w1,
                    'StartPromoDate', w2,
                    'EndPromoDate', w2,
                    'PromoTimeFg', w3,
                    'StartPromoTime', w1,
                    'EndPromoTime', w1,
                    'PromoDayFg', w3,
                    'PromoDay', w1,
                    'PromoShopFg', w3,
                    'PromoShop', w1,
                    'PromoCustFg', w4,
                    'PromoCust', w1,
                    'VenderSharing', w5,
                    'PromoStatus', w3,
                    'ItemList', w6,
                    'ItemExList', w7
                ]);
            }
        }
    }
}
